/*
 *
 * Copyright (c) Vaisala Oyj. All rights reserved.
 *
 */

import * as React from 'react';

import { AppRoute } from '../../Routes';
import { Link } from 'react-router-dom';
import { NavigationRouteHierarchy } from '@vaisala/rockhopper-components';
import { useTranslation } from 'react-i18next';
import { useProject } from '../project';
import { useAuth } from '../auth/AuthContext'; 

const pageLink = (path: string, name: string) => <Link to={path}>{name}</Link>;

export function useCurrentNavItems(routes: Array<AppRoute>) {
  const { t } = useTranslation();
  const { project } = useProject();
  const { status, role } = useAuth()
  const items = React.useMemo(
    () =>
      routes.reduce((items, { path, name }) => {
        if ((path as string) === '/project/' + project.name){
          items[path as string] = { title: project.name, items: {} };
        }
        else if ((path as string) === '/project/' + project.name + '/data_management'){
          if(items['/project/' + project.name] && items['/project/' + project.name]['items'])
            (items['/project/' + project.name]['items'] as {[index: string]: React.ReactNode})[path as string] = pageLink(path as string, t(name as string));
        }
        else if ((path as string) === '/project/' + project.name + '/monitoring'){
          if(items['/project/' + project.name] && items['/project/' + project.name]['items'])
            (items['/project/' + project.name]['items'] as {[index: string]: React.ReactNode})[path as string] = pageLink(path as string, t(name as string));
        }
        else if ((path as string) === '/project/' + project.name + '/wind_reconstruction'){
          if(items['/project/' + project.name] && items['/project/' + project.name]['items'])
            (items['/project/' + project.name]['items'] as {[index: string]: React.ReactNode})[path as string] = pageLink(path as string, t(name as string));
        }
        else if ((path as string) === '/admin' && role === 'admin' ){
          items[path as string] = { title: 'Admin', items: {} };
        }
        else if ((path as string) === '/admin/usersmanagement'  && role === 'admin'){
          if(items['/admin'] && items['/admin']['items'])
            (items['/admin']['items'] as {[index: string]: React.ReactNode})[path as string] = pageLink(path as string, t(name as string));
        }
        else if ((path as string) === '/admin/lidars'  && role === 'admin'){
          if(items['/admin'] && items['/admin']['items'])
            (items['/admin']['items'] as {[index: string]: React.ReactNode})[path as string] = pageLink(path as string, t(name as string));
        }
        else{
          items[path as string] = { item: pageLink(path as string, t(name as string)) };
        }
        return items;
      }, {} as NavigationRouteHierarchy),
  [routes, t, project.name] 
  );
  // ensure other routes are never visible when not logged in
  // could fine tune this by adding filtering in the reduce for routes requiring auth
  return { items: status === 'ACTIVE' ? items : ({} as NavigationRouteHierarchy), show:  status === 'ACTIVE' };
}
